import { LOTTO_TYPE_DISPLAY, LOTTO_TYPE_DISPLAY_WHITE_BALL } from "../contexts/constants";

/**
 * Lotto Winning
 */
export const LottoBallsWinning = ({ grayBalls = [], specialBall = 0, winningGrayBalls = [], winningSpecialBall = 0, type, wh, paymentStatus }) => {
  const safeBalls = Array.isArray(grayBalls) ? grayBalls : [];
  const safeWinningBalls = Array.isArray(winningGrayBalls) ? winningGrayBalls : [];

  const isGrayBallWinning = (number) => safeWinningBalls.includes(number);
  const isSpecialBallWinning = specialBall === winningSpecialBall;
  const colorType = type === 'powerball' ? 'red' : 'yellow';

  wh = (wh === 0 || wh === undefined || wh === '') ? 8 : wh;
  let disabledBall = false;
  if(paymentStatus === 'rejected') {
    disabledBall = true;
  }

  return (
    <div className="flex items-center justify-start gap-1.5">
      {/* แสดงบอลเทา 5 ลูก */}
      {safeBalls.map((number, index) => {
        const isWinning = isGrayBallWinning(number);
        return (
          <div
            key={`gray-${index}-${number}`}
            className={`relative w-${wh} h-${wh} rounded-full flex items-center justify-center shadow-md text-xs font-bold text-black ${LOTTO_TYPE_DISPLAY_WHITE_BALL[type]} ${
              disabledBall ? (
                'border-gray-200'
              ) : isWinning ? (
                'border-green-500'
              )
              : (
                `border-${colorType}-500`
              )
            }`}
          >
            {number}
            {isWinning && !disabledBall && (
              <div className="absolute -bottom-1 -left-1 w-3 h-3 bg-green-500 rounded-full flex items-center justify-center">
                <svg className="w-2 h-2 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            )}
          </div>
        );
      })}

      {/* เครื่องหมาย + */}
      <span className="text-lg font-bold text-gray-700 dark:text-gray-300 mx-1">+</span>

      {/* แสดง special ball 1 ลูก */}
      <div className={`relative w-${wh} h-${wh} rounded-full flex items-center justify-center font-bold text-xs text-white shadow-lg ${
        isSpecialBallWinning
          ? LOTTO_TYPE_DISPLAY[type]
          : LOTTO_TYPE_DISPLAY[type]
      }`}>
        {specialBall || 1}
        {isSpecialBallWinning && !disabledBall && (
          <div className="absolute -bottom-1 -left-1 w-3 h-3 bg-green-500 rounded-full flex items-center justify-center">
            <svg className="w-2 h-2 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

/**
 * Lotto Color
 */
export const LottoBallsDisplay = ({ grayBalls = [], specialBall = '', type, wh, paymentStatus}) => {
	// Safety check to ensure grayBalls is an array
	const safeBalls = Array.isArray(grayBalls) ? grayBalls : [];
	wh = (wh === 0 || wh === undefined || wh === '') ? 8 : wh;
	const textSize = wh === 10 ? '' : 'text-xs';
	// const colorType = type === 'powerball' ? 'red' : 'yellow';
	const nameTypeShort = type === 'powerball' ? 'BALL' : 'MEGA';

  	let elSpecialBall = <>
		{/* เครื่องหมาย + */}
		{grayBalls.length > 0 ? <span className="text-lg font-bold text-gray-700 dark:text-gray-300 mx-1">+</span> : null}

		{/* แสดงบอลแดง 1 ลูก */}
		<div className={`w-${wh} h-${wh} rounded-full flex items-center justify-center font-bold ${textSize} ${LOTTO_TYPE_DISPLAY[type]}`}>
		{specialBall || ''}
		</div>
	</>
	if(specialBall === true || specialBall === false) {
		elSpecialBall = specialBall === true ? <>
			{/* เครื่องหมาย + */}
			{grayBalls.length > 0 ? <span className="text-lg font-bold text-gray-700 dark:text-gray-300 mx-1">+</span> : null}

			{/* แสดงบอลแดง 1 ลูก */}
			<div className={`w-9 h-9 rounded-full flex items-center justify-center font-bold text-[10px] ${textSize} ${LOTTO_TYPE_DISPLAY[type]}`}>
			{nameTypeShort}
			</div>
		</> : null;
	}

  return (
    <div className="flex items-center justify-start gap-1.5">
      {/* แสดงบอลเทา 5 ลูก */}
      {safeBalls.length > 0 ? safeBalls.map((number, index) => (
      <div
        key={`gray-${index}-${number}`}
        className={`w-${wh} h-${wh} rounded-full flex items-center justify-center ${textSize} font-bold text-black ${LOTTO_TYPE_DISPLAY_WHITE_BALL[type]}`}
      >
        {number}
      </div>
      )) : (
      // Fallback if no gray balls
      grayBalls.map((number, index) => (
        <div
        key={`fallback-gray-${index}`}
        className={`w-${wh} h-${wh} rounded-full flex items-center justify-center bg-gradient-to-br from-gray-200 to-gray-300 dark:from-gray-300 dark:to-gray-400 shadow-md border border-gray-300 dark:border-gray-400 text-xs font-bold text-black`}
        >
        {number}
        </div>
      ))
      )}

	  {elSpecialBall}
    </div>
  );
};
